import React from 'react';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router-dom';
import { userShare } from '@/api';
import Logo from '@/assets/images/share/logo.png';
import { LIBRARY_ASSETS_ORIGIN_URL } from '@/constants';
import './style.less';

@withRouter
class ShareRecording extends React.Component {
  static propTypes = {
    match: PropTypes.object,
  };

  constructor() {
    super();
    this.state = {
      params: null,
      imgSrc: '',
      txt: '',
      audioSrc: '',
      playing: false,
    };
    this.audio = React.createRef();
  }

  componentDidMount() {
    this.setState({ params: this.props.match ? this.props.match.params : null }, () => {
      this.getUserShare();
    });
  }

  getUserShare = async () => {
    const { params } = this.state;
    const result = await userShare.list(params.shareId, params.id, params.attempt);
    this.init(result.data);
  };

  init = (list) => {
    const host = `${LIBRARY_ASSETS_ORIGIN_URL}resource/`;
    const audioSrc = list[0].share_audio_content;
    const txt = list[0].share_source[0].introduce_word;
    const imgSrc = `${host}img/reachout/${list[0].share_source[0].image_name}`;
    this.setState({ imgSrc, txt, audioSrc });
  }

  handlePlay = () => {
    const { playing, audioSrc } = this.state;
    !playing
      ? this.setState({ playing: true, audioSrc: `${audioSrc}?t=${Date.now()}` }, () => {
        this.audio.current.currentTime = 0;
        this.audio.current.play();
      })
      : this.setState({ playing: false }, () => {
        this.audio.current.pause();
      });
  }

  stop = () => {
    this.audio.current.pause();
    const { audioSrc } = this.state;
    this.setState({ playing: false, audioSrc });
  }

  render() {
    const {
      txt,
      imgSrc,
      audioSrc,
      playing,
    } = this.state;
    return (
      <div className="share-recording-container">
        <div className="share-recording">
          <div className="share-recording-wrapper">
            <div className="share-recording-header">
              <img src={Logo} alt="" />
            </div>
            <div className="share-pic">
              <img src={imgSrc} alt="" />
              <div className={`recording-play${playing ? ' suspend' : ''}`} onClick={this.handlePlay} />
            </div>
            <div className="share-content">
              {txt}
            </div>
          </div>
        </div>
        <audio
          controls="controls"
          preload="auto"
          ref={this.audio}
          style={{ display: 'none' }}
          src={audioSrc}
          onEnded={this.stop}
        />
      </div>
    );
  }
}

export default ShareRecording;
